module.exports = __webpack_public_path__ + "static/media/FoodIconsSizeCheck.2a0c9dfc.jpg";